<template>
  <v-container fluid class="order-detail d-flex flex-column px-0" v-if="order">
    <CategoryTitle :category="category" :add-container="false" />
    <v-row justify="space-between" class="mb-3">
      <v-col cols="12">
        <OrderDetailInfo
          :order="order"
          @addAllToCart="addAllToCart"
          @deleteOrder="deleteOrder"
          @editOrder="editOrder"
          @showPayment="showPayment = !showPayment"
        />
      </v-col>

      <v-col cols="12" v-if="showPayment" class="ma-0 grey lighten-1 mb-5">
        <span class="d-block text-h2 line-height-1 mt-3">{{
          $t("order.retryPayment")
        }}</span>
        <PaymentTypeList
          mode="order"
          :order-id="order.orderId"
          :options="paymentTypeListOptions"
          :paymentNameToPaymentInfo="true"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-col cols="12" class="px-0 pt-0">
          <CartInfoAddressCard
            :shippingAddress="order.shippingAddress"
            class="w-100 cart-info-timeslot-card"
          />
        </v-col>
        <v-col cols="12" class="px-0">
          <CartInfoTimeslotCard
            v-if="order"
            :shippingAddress="order.shippingAddress"
            :timeslot="order.timeslot"
            class="w-100 cart-info-timeslot-card"
            :value="value"
          /> </v-col
      ></v-col>
      <v-col cols="12" sm="6">
        <CheckoutSummary
          :orderCart="order"
          :title="$t(`order.paymentType[${this.order.paymentTypeId}]`)"
          :delivered="delivered"
          :canDeleteGift="false"
        />
      </v-col>
    </v-row>

    <OrderDetailTable
      :suborders="itemList"
      :order="order"
      class="mt-4 mt-sm-12"
      :delivered="delivered"
      @toggleItemForRefund="toggleItemForRefund"
      @reload="reload"
    />
    <v-row
      v-if="!refundItems"
      no-gutters
      class="backbtn-container mt-5 justify-center justify-sm-start"
    >
      <v-btn color="primary" outlined v-bind:to="{ name: 'Orders' }" exact>
        <v-icon class="mr-3">$prev</v-icon>
        <span v-html="$t('orders.button.backToOrders')"></span>
      </v-btn>
      <v-btn
        v-if="showSaveBtn"
        color="primary"
        class="ml-3 mt-3 mt-sm-0"
        @click="saveSubstitute"
      >
        <span v-html="$t('orders.button.saveSubstitutes')"></span>
      </v-btn>
    </v-row>
    <v-row no-gutters v-else class="backbtn-container mt-5 justify-end">
      <v-btn
        color="primary"
        depressed
        v-bind:to="{
          name: 'RefundRequest',
          query: {
            orderId: order.orderId,
            itemId: refundItems
          }
        }"
      >
        <span v-html="$t('refund.sentRequests')"></span>
      </v-btn>
    </v-row>
    <div class="mt-6">
      <h2 class="text-h4">{{ $t("refund.refundForOrder") }}</h2>
      <RefundTable :orderId="order.orderId" class="generic-list" />
    </div>
  </v-container>
</template>
<style lang="scss">
.order-detail {
  .card {
    padding: 10px 20px !important;
    box-sizing: border-box;
    background-color: var(--v-grey-lighten3) !important;
    border: 1px solid var(--v-grey-lighten3) !important;
    border-radius: 8px;
    &:hover {
      background-color: var(--v-primary-lighten2);
    }
    &.cart-info {
      padding: 35px 0 27px 12px !important;
      .text,
      .value {
        line-height: 24px !important;
      }
      @media #{map-get($display-breakpoints, 'sm-only')} {
        padding: 20px !important;
      }
    }
  }
  .payment-methods {
    margin-top: 0px !important;
  }
  .cart-info-timeslot-card,
  .cart-info-address-card {
    pointer-events: none;
  }
  .remove-gift {
    display: none;
  }
}

@media print {
  .order-detail {
    .cart-info-cards {
      flex-direction: row !important;
      gap: 12px !important;
    }

    .cart-info-cards div:first-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
<script>
// @ is an alias to /src
import OrderDetailTable from "@/components/orders/OrderDetailTable.vue";
import OrderDetailInfo from "@/components/orders/OrderDetailInfo.vue";
import CartInfoAddressCard from "@/components/cart/CartInfoAddressCard.vue";
import CartInfoTimeslotCard from "@/components/cart/CartInfoTimeslotCard.vue";
import CheckoutSummary from "@/components/cart/CheckoutSummary.vue";
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import PaymentTypeList from "~/components/payment/PaymentTypeList.vue";
import RefundTable from "@/components/orders/RefundTable.vue";

import OrderService from "~/service/orderService";
import AnalyticsService from "~/service/analyticsService";

import categoryMixins from "~/mixins/category";
import reload from "~/mixins/reload";

import { mapState, mapActions, mapGetters } from "vuex";
import CustomService from "@/service/customService";
import RefundService from "@/service/refundService";

export default {
  name: "Order",
  data() {
    return {
      review: {
        rating: 3,
        comment: "",
        active: 1,
        title: "",
        noteId: null,
        productId: -1
      },
      order: null,
      itemList: [],
      valid: true,
      showPayment: false,
      requiredRules: [v => !!v || "Campo obbligatorio"],
      paymentTypeListOptions: {
        flatPanels: true,
        showPaymentMethodImage: true,
        showCardLogos: false,
        mainBackgroundColor: "transparent",
        titleStyle: "default--text text-uppercase payment-type-list-title",
        back: {
          label: "Torna Indietro",
          class: "paymenbt-back-button",
          show: true
        }
      },
      menuNewDate: false,
      refundItems: null
    };
  },
  mixins: [categoryMixins, reload],
  components: {
    OrderDetailInfo,
    OrderDetailTable,
    CartInfoAddressCard,
    CartInfoTimeslotCard,
    CheckoutSummary,
    CategoryTitle,
    PaymentTypeList,
    RefundTable
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    ...mapGetters({
      isSsoUser: "cart/isSsoUser"
    }),
    // canIRateOrder() {
    //   return this.order.orderStatusId === 8 || this.order.orderStatusId === 18;
    // },
    enableSave() {
      return !this.valid;
    },
    serviceImg() {
      return this.$t(
        "navbar.service." +
          this.order.shippingAddress.deliveryServiceId +
          ".icon",
        {
          color: "color"
        }
      );
    },
    value() {
      if (this.order.timeslot) {
        let date = this.$dayjs(this.order.timeslot.date);
        return (
          "Da " +
          date.format("ddd D MMMM") +
          " nella fascia oraria " +
          this.$dayjs(this.order.timeslot.beginTime, [
            "h:mm:ss A",
            "H:mm"
          ]).format("HH:mm") +
          " - " +
          this.$dayjs(this.order.timeslot.endTime, [
            "h:mm:ss A",
            "H:mm"
          ]).format("HH:mm")
        );
      }
      return this.$t("navbar.noTimeslot");
    },
    delivered() {
      return (
        this.order.orderStatusId == 6 ||
        this.order.orderStatusId == 8 ||
        this.order.orderStatusId == 18
      );
    },
    showSaveBtn() {
      return (
        this.order.orderInfos.SUBSTITUTES_CONFIRMED != "true" &&
        this.order.orderStatusId == 6
      );
    }
  },
  methods: {
    // getTimeslotTime(time) {
    //   if (time) {
    //     const parseTime = this.am_pm_to_hours(time);
    //     var d = new Date();
    //     var timeMatch = parseTime.match(/(\d+)(?::(\d\d))?\s*(p?)/);
    //     d.setHours(parseInt(timeMatch[1]) + (timeMatch[3] ? 12 : 0));
    //     d.setMinutes(parseInt(timeMatch[2]) || 0);
    //     const timeOnly = this.$dayjs(d).format("HH:mm");
    //     return timeOnly;
    //   } else return "";
    // },
    // am_pm_to_hours(time) {
    //   var hours = Number(time.match(/^(\d+)/)[1]);
    //   var minutes = Number(time.match(/:(\d+)/)[1]);
    //   var AMPM = time.match(/\s(.*)$/)[1];
    //   if (AMPM == "PM" && hours < 12) hours = hours + 12;
    //   if (AMPM == "AM" && hours == 12) hours = hours - 12;
    //   var sHours = hours.toString();
    //   var sMinutes = minutes.toString();
    //   if (hours < 10) sHours = "0" + sHours;
    //   if (minutes < 10) sMinutes = "0" + sMinutes;
    //   return sHours + ":" + sMinutes;
    // },
    ...mapActions({
      addProductsFromOrder: "cart/addProductsFromOrder",
      loadCart: "cart/loadCart"
    }),
    async addAllToCart({ orderId }) {
      let res = await global.vm.$dialog.confirm({
        text: global.vm.$t("message.addAllFromOrder")
      });
      if (res) {
        await this.addProductsFromOrder(orderId);
      }
    },
    async deleteOrder({ orderId }) {
      let res = await this.$dialog.confirm({
        text: global.vm.$t("message.removeOrder", {
          orderId: orderId
        })
      });

      if (res) {
        await OrderService.deleteOrder(orderId);
        AnalyticsService.refund(this.order);
        await this.reload(orderId);
      }
    },
    async editOrder({ orderId }) {
      try {
        let res = await global.vm.$dialog.confirm({
          text: global.vm.$t("message.confirmOrderEdit")
        });
        if (res) {
          await OrderService.editOrder(orderId);
          this.loadCart();
          this.$router.push({
            name: "Checkout"
          });
        }
      } catch (err) {
        global.EventBus.$emit("error", {
          error: err,
          message: global.EventBus.$t("errors.errorOnOrderEditConfirm")
        });
        return null;
      }
    },
    async reload(orderId) {
      this.order = await OrderService.getOrder(orderId, true);
      this.handleItems();
      if (this.order.isPayable) {
        this.showPayment = true;
      }
    },
    changeDateOrder() {
      CustomService.changeDateOfOrder(
        this.order.orderId,
        this.order.timeslot.date
      );
    },
    handleItems() {
      this.itemList = [];
      for (let s = 0; s < this.order.suborders.length; s++) {
        let suborder = this.order.suborders[s];
        // for (let i = 0; i < suborder.suborderItems.length; i++) {
        //   let item = suborder.suborderItems[i];
        //   if (!item.orderItemReplacedId) {
        //     let alternative = null;
        //     let type = "ordered";
        //     for (let j = 0; j < suborder.suborderItems.length; j++) {
        //       var itemAlternative = suborder.suborderItems[j];
        //       if (
        //         itemAlternative.orderItemReplacedId &&
        //         item.orderItemId === itemAlternative.orderItemReplacedId
        //       ) {
        //         alternative = itemAlternative;
        //         type = "replaced";
        //         break;
        //       }
        //     }
        //     this.itemList.push(this.handleOrderItem(item, type));
        //     if (alternative) {
        //       this.itemList.push(
        //         this.handleOrderItem(itemAlternative, "alternative")
        //       );
        //     }
        //   }
        // }
        suborder.suborderItems.sort(this.compareSuborderItemsPriority);

        this.itemList = this.itemList.concat(suborder.suborderItems);
      }
      for (let i = 0; i < this.itemList.length; i++) {
        let item = this.itemList[i];

        item.deliveredType = "ordered";
        if (item.deliveredQuantity < item.quantity) {
          item.deliveredType = "partial";
        }
        if (item.deliveredQuantity > 0 || item.deliveredWeight > 0) {
          if (item.orderItemReplacedId) {
            item.deliveredType = "alternative";
          }
        } else {
          // doubtful request from core because there is wrong orderItem with quantity 0 and replaced status, and then the same product but correctly picked
          if (
            i < this.itemList.length - 2 &&
            this.itemList[i + 1].product.productId == item.product.productId &&
            item.orderItemReplacedId
          ) {
            item.wrongPickedProduct = true;
          }
          item.deliveredType = "replaced";
        }
      }
    },
    compareSuborderItemsPriority(item1, item2) {
      if (item1.orderItemReplacedId) {
        if (item2.orderItemReplacedId) {
          if (item1.orderItemReplacedId == item2.orderItemReplacedId) {
            if (
              item1.deliveredQuantity > item2.deliveredQuantity ||
              item1.deliveredWeight > item2.deliveredWeight
            ) {
              return 1;
            } else {
              return -1;
            }
          }

          if (item1.orderItemReplacedId > item2.orderItemReplacedId) {
            return 1;
          }

          if (item1.orderItemReplacedId < item2.orderItemReplacedId) {
            return -1;
          }
        }
        if (item1.orderItemReplacedId > item2.orderItemId) {
          return 1;
        }
        if (item1.orderItemReplacedId < item2.orderItemId) {
          return -1;
        }
        if (item1.orderItemReplacedId == item2.orderItemId) {
          return 0;
        }
      } else {
        if (item1.orderItemId < item2.orderItemId) {
          return -1;
        }
        if (item1.orderItemId > item2.orderItemId) {
          return 1;
        }
        return 0;
      }
    },
    handleOrderItem(orderItem, type) {
      if (this.delivered) {
        let q2 =
          (orderItem.deliveredQuantity > 0
            ? orderItem.deliveredQuantity
            : orderItem.deliveredWeight) || 0;

        orderItem.deliveredType = q2 === 0 ? "replaced" : type;
      }

      return orderItem;
    },
    toggleItemForRefund(item) {
      if (!this.refundItems) {
        this.refundItems = [];
      }
      if (this.refundItems.includes(item.orderItemId)) {
        this.refundItems.splice(this.refundItems.indexOf(item.orderItemId), 1);
        if (this.refundItems.length == 0) {
          this.refundItems = null;
        }
      } else {
        this.refundItems.push(item.orderItemId);
      }
    },
    async saveSubstitute() {
      let res = await global.vm.$dialog.confirm({
        text: global.vm.$t("message.confirmOrderEdit")
      });
      if (res) {
        RefundService.saveSubstitute(this.order.orderId).then(() => {
          this.reload(this.order.orderId);
        });
      }
    }
  },
  created() {
    this.reload(this.$route.params.orderId);
  }
};
</script>
